import { Button, Dialog, Divider, Grid, IconButton, InputAdornment, TextField, FormControl, MenuItem, Typography, Link , CircularProgress } from '@mui/material';
import { makeStyles, useTheme } from '@mui/styles';
import { getUrl, postUrl } from '@utils/ApiAction';
import { currencyFormat } from '@utils/Tools';
import useNotificationLoading from '@utils/useNotificationLoading';
import React, { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { storePaths } from '@utils/Tools';
import { useSelector } from 'react-redux';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';

import _ from 'lodash';
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import { FiX } from "react-icons/fi";

import DialogDesign from '@components/DialogDesign';

export default function PurchasePlan() {
    const theme = useTheme();
    const { t, i18n } = useTranslation();
    const { addAlert, setLoading } = useNotificationLoading();
    const [inputErrors, setInputErrors] = useState({});
    const [totalPayAmount, setTotalPayAmount] = useState(0);
    const [password , setPassword] = useState(false);
    const { username } = useSelector(state => state.user);
    const styles = useStyles();
    let navigate = useNavigate();
    let location = useLocation();

    const [state, setState] = useState({
        packages: [],
        paymentMethods: [],
        wallet: [],
        securityPassword: "",
        confirmation: false,
        step: 1,
        planHistory: [],
        package_id: '',
        package_image: '',
        combination_id: '',
        recipientUsername: username,
        service_fee: 0,
        total_amount: 0,
        service_fee_wallet: {},
    });
    const [showPassword, setShowPassword] = useState({
        securityPassword: false,
    });
    const [ load , setLoad ] = useState({
        service_fee: false,
    })
    const handleChange = ({ target }) => {
        const { name, value } = target;
        setState({ ...state, [name]: value });
    }

    const handleClickShowPassword = (value) => {
        setShowPassword({
            ...showPassword,
            [value]: !showPassword[value]
        });
    };

    const calculateServiceFee = useCallback((pkg) => {
        setLoad({
            ...load, 
            service_fee: true
        });
        let service_fee = 0;
        const info = _.clone(pkg?.extra_setting?.service_fee);

      
        if (pkg && _.size(info) > 0) {
          if (info?.type === 'percent') {
            service_fee = pkg.price * info?.amount;
          } else {
            service_fee = info?.amount;
          }
        }
      
        return Math.ceil(service_fee * 100) / 100 || 0;
    }, []);

    useEffect(() => {
        if (_.size(state?.packages) === 0) return;
      
        const package_selected = _.find(state?.packages, { id: state?.package_id });
        if (!package_selected) return;
      
        const price = parseFloat(package_selected?.price) || 0;
        const service_fee = calculateServiceFee(package_selected);
        const total_amount = price + parseFloat(service_fee || 0);
        const service_fee_wallet = _.find(state?.wallet, { id: parseInt(package_selected?.extra_setting?.service_fee?.walletId) });
      
        setState(prev => {
          if (
            prev.service_fee === service_fee &&
            prev.total_amount === total_amount &&
            prev.service_fee_wallet === service_fee_wallet
          ) return prev;
      
          return {
            ...prev,
            service_fee,
            total_amount,
            service_fee_wallet
          };
        });

        setLoad({
            ...load, 
            service_fee: false
        });
      }, [state , calculateServiceFee]);
            
    useEffect(() => {
        setLoading(true);
        getUrl('/plan/setting').then(response => {
            if (response.status) {
                setState({ ...state, wallet: response.data.wallets, packages: response.data.packages, package_id: response.data.packages[0].id, package_image: response.data.packages[0].plan_logo?.file_name });
            }
        }).catch(error => {
            addAlert('', error.message || t('error.contactSupport'), 'error', '');
        }).finally(() => {
            setLoading(false);
        });
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        let package_data = state.packages.find((element) => element.id == state.package_id);
        if (package_data) {
            setState({ ...state, package_image: package_data?.plan_logo?.file_name })
        }
        if (state.package_id) {
            getUrl(`/user/plan-get-multipricing/${state.package_id}`).then(response => {
                if (response.status) {
                    let combination_id = '';
                    if (Object.keys(response?.data?.payment_methods).length > 0) {
                        combination_id = Object.keys(response?.data?.payment_methods)[0];
                    }
                    setState({ ...state, paymentMethods: response.data.payment_methods, combination_id: combination_id });
                }
            }).catch(error => {
                addAlert('', error.message || t('error.contactSupport'), 'error', '');
            })
        }
        // eslint-disable-next-line
    }, [state.package_id])

    const purchase = () => {
        setLoading(true);
        setInputErrors();
        setPassword(false);
        let param = {
            package_id: state.package_id,
            combination_id: state.combination_id,
            security_password: state.securityPassword,
            recipient_username: state.recipientUsername,
            service_fee: state?.service_fee,
            total_amount: state?.total_amount,
        };
        postUrl(`/purchase-plan`, param).then(response => {
            setLoading(false);
            if (response.status) {
                setState({ ...state, securityPassword: '', step: 2, confirmation: false, planHistory: response.data });
                addAlert('', t('success.purchaseSuccess'), 'success', '');
            } else {
                setInputErrors(response.errors);
                setPassword(response?.set_password)
                let msg = response.message;
                _.map(response.errors, (value, index) => {
                    msg += "\n " + value;
                })
                addAlert('', msg || response.message, 'error', '');
            }
        }).catch(error => {
            setLoading(false);
            addAlert('', error.message || t('error.contactSupport'), 'error', '');
        });
    }

    const navigateSecurityPassword = () => {
        window.open('/setting/security-password','_blank');
        setPassword(false);
    }

    const packagePriceRender = (step) =>{
        let selectedMultipricing = state.paymentMethods[state.combination_id];
        let packagePricing =_.find(state.packages, { id: state.package_id })?.price;
        let totalAmount = 0;
        let index = 0;
        let paymentArray = {};
        _.map(selectedMultipricing , (detail, walletId) =>{
            if(detail.type === 'fixed'){
                totalAmount += detail.amount;
                paymentArray[walletId] = (paymentArray?.[walletId] ?? 0) + detail.amount;
            }else{
                paymentArray[walletId] = (paymentArray?.[walletId] ?? 0) + (packagePricing * (detail.amount/100));
                totalAmount+=(packagePricing * (detail.amount/100))
            }
        });
        if(step === 1 ){
            return (
                <div className='w-full flex-col-m p-t-40' style={{gap:10}}>
                    <div className='w-full cl-theme flex-sb-m'>
                        <p><b>{t('package.totalPrice') + ': '}</b></p>
                    </div>
                    {
                        _.map(paymentArray , (amount, walletId) => {
                            index++;
                            let walletName = _.find(state.wallet, { 'id': Number(walletId) })?.name[i18n.resolvedLanguage];
                            return (
                                <div className='w-full fs-18 cl-theme flex-sb-m' key={walletId}>
                                    <div className='flex-c-m'>
                                        <p>{index + '. '}</p>
                                        <p>{walletName}</p>
                                    </div>
                                    <p className='cl-theme'><b>{'$ ' + currencyFormat(amount, 2)}</b></p>
                                </div>
                            )
                        })
                    }
                    <div className='w-full cl-theme flex-sb-m'>
                        {
                            load?.service_fee ?
                            <CircularProgress color="primary" size="30px" />
                            :
                                <>
                                    <p>{`${t('package.serviceFee')}  ${_.size(state?.service_fee_wallet) > 0 ? `( ${(state?.service_fee_wallet?.name[i18n.resolvedLanguage] ?? state?.service_fee_wallet?.name['en'])} )` : ''} : `}</p>
                                    <p>{'$ ' + currencyFormat(state?.service_fee, 2)}</p>
                                </>
                        }
                    </div>
                    <div className='w-full cl-theme flex-sb-m'>
                        <p><b>{t('wallet.totalAmount') + ': '}</b></p>
                        <p><b>{'$ ' + currencyFormat(totalAmount+(state?.service_fee??0) ?? 0, 2)}</b></p>
                    </div>
                </div>
            )
        }else if(step === 'dialog'){
            return (
                <>
                    <div className='p-t-24 flex-sb-m'>
                        <p>{t('package.totalPrice')}</p>
                        <p>{'$ ' + currencyFormat(totalAmount+(state?.service_fee??0) ?? 0, 2)}</p>
                    </div>
                    <div className='p-t-24 flex-sb-m'>
                        <p>{t('package.paymentMethod')}</p>
                        <div className='txt-right'>
                            {
                                _.map(paymentArray, (amount, walletId) => {
                                    index++;
                                    let walletName = _.find(state.wallet, { 'id': Number(walletId) })?.name[i18n.resolvedLanguage];
                                    return (
                                        <div key={walletId}>
                                            <p key={walletId} className='fs-16 cl-white p-r-5'>
                                                {' ' + walletName + ' (' + currencyFormat(amount, 2) + ')'}
                                            </p>
                                        </div>
                                    )
                                })
                            }
                            {/* {
                                _.map(state.paymentMethods, (wallets, combination_id) => {
                                    return (
                                        <div key={combination_id}>
                                            {
                                                combination_id == state.combination_id ?
                                                    _.map(wallets, (percent, wallet_id) => {
                                                        let wallet = state.wallet.find((element) => element.id == wallet_id);
                                                        return (
                                                            <p key={combination_id + wallet.id} value={combination_id} className='fs-16 cl-white p-r-5'>
                                                                {' ' + (wallet?.name[i18n.resolvedLanguage] ?? wallet?.name['en']) + ' (' + percent + '%)'}
                                                            </p>
                                                        )
                                                    })
                                                    : null
                                            }
                                        </div>
                                    )
                                })
                            } */}
                        </div>
                    </div>
                    <div className='p-t-24 flex-sb-m'>
                        <p>{t('package.serviceFee')}</p>
                        <p>{` ${_.size(state?.service_fee_wallet) > 0 ? ` ${(state?.service_fee_wallet?.name[i18n.resolvedLanguage] ?? state?.service_fee_wallet?.name['en'])} ` : ''} ( ${currencyFormat(state?.service_fee, 2)} ) `}</p>
                    </div>
                </>
            )
        }else if(step === 2){
            return (
                <div className='w-full flex-sb-m'>
                    <p>{t('package.totalPrice')}</p>
                    <div className='txt-right' style={{ width: '50%', wordBreak: 'break-all' }}>
                        <p style={{ fontWeight: 600 }}>{'$ ' + currencyFormat(totalAmount+(state?.service_fee??0) ?? 0, 2)}</p>
                    </div>
                </div>
            )
        }else{
            return true;
        }
       
    }

    return (
        <div style={{ maxHeight: '100vh', overflowY: 'auto'  }}>
             {/* <div className='w-full p-lr-24 p-b-30'>
                <div className='pointer cl-theme' onClick={() => navigate("/packages/histories", { state: { from: storePaths(location) } })}>
                    <p>{t('wallet.planHistories')}</p>
                </div>
            </div> */}
            {
                state.step === 1 ?
                    <>
                        {
                            _.size(state.packages) > 0 ?
                                <div>
                                    <div className='flex-c-m' style={{ width: 150, height: 150, margin: '0 auto' }}>
                                        <img className='w-full' style={{ objectFit: 'cover' }} src={state.package_image ? state.package_image : `/images/wallet/coin.png`} alt="package" />
                                    </div>
                                    <div className='cl-white p-lr-24 p-b-120'>
                                        <p className='fs-16  p-t-24'>{t('general.pleaseSelect')}</p>

                                        <FormControl fullWidth>
                                            <Select
                                                id="package_id"
                                                value={state.package_id || ""}
                                                name="package_id"
                                                onChange={handleChange}
                                            >
                                                {_.map(state.packages, (_package) => (
                                                    <MenuItem key={_package.id} value={_package.id}>{_package.name[i18n.resolvedLanguage] ?? _package.name['en']}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                        <div className='p-t-24'>
                                            <p className='p-t-5 fs-16' style={{ fontWeight: 600 }}>{t('package.recipientUsername')}</p>
                                            <TextField
                                                fullWidth
                                                name="recipientUsername"
                                                placeholder={t('package.recipientUsername')}
                                                onChange={handleChange}
                                                inputProps={{
                                                    autoComplete: 'new-recipient'
                                               }}
                                               value={state.recipientUsername}
                                            />
                                        </div>

                                        <div className='p-t-24'>
                                            <p className='p-t-5 fs-16' style={{ fontWeight: 600 }}>{t('package.paymentMethod')}</p>
                                            <FormControl fullWidth>
                                                <Select
                                                    id="combination_id"
                                                    value={state.combination_id }
                                                    name="combination_id"
                                                    onChange={handleChange}
                                                >
                                                    {
                                                        _.map(state.paymentMethods, (wallets, combination_id) => {
                                                            return (
                                                                <MenuItem key={combination_id} value={combination_id}>
                                                                    <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                                                        {
                                                                            _.map(wallets, (detail, wallet_id) => {
                                                                                let wallet = state.wallet.find((element) => element.id == wallet_id);
                                                                                if(detail.type === 'fixed'){
                                                                                    return (
                                                                                        <Typography key={combination_id + wallet.id} value={combination_id} className='cl-white p-r-5'>
                                                                                            {' ' + (wallet?.name[i18n.resolvedLanguage] ?? wallet?.name['en']) + ' ( ' + detail.amount + ' )'}
                                                                                        </Typography>
                                                                                    )
                                                                                }else{
                                                                                    return (
                                                                                        <Typography key={combination_id + wallet.id} value={combination_id} className='cl-white p-r-5'>
                                                                                            {' ' + (wallet?.name[i18n.resolvedLanguage] ?? wallet?.name['en']) + ' ( ' + detail.amount + ' %)'}
                                                                                        </Typography>
                                                                                    )
                                                                                }
                                                                            })
                                                                        }
                                                                    </div>
                                                                </MenuItem>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                            </FormControl>
                                        </div>
                                        {
                                            packagePriceRender(1)
                                        }
                                        <div className='p-tb-20'>
                                            <Button fullWidth variant="contained" onClick={() => setState({ ...state, confirmation: true })}>{t('button.purchase')}</Button>
                                        </div>
                                    </div>
                                </div>
                                : null
                        }
                    </>
                    :
                    <div className='p-lr-24 p-b-24 p-t-50'> {/* done purchase */}
                        <div className='bor15 bg-base shadow-in-box'>
                            <div className='p-t-40 txt-center'>
                                <img src="/logo-text.png" style={{ height: 50 }} alt="logo" />
                                <p className='fs-18 p-t-24 cl-theme' style={{ fontWeight: 600 }}>{t('package.success')}</p>
                                <p className='p-t-4 fs-14 cl-white'>{t('package.successDesc')}</p>
                            </div>
                            <div className='w-full p-lr-24 p-b-10'>
                                <div className='divider-dark m-tb-24' />
                                <div className='cl-white flex-col-m fs-15 pos-relative' style={{ gap: 15 }}>
                                    {packagePriceRender(2)}
                                    <div className='w-full flex-sb-m'>
                                        <p>{t('package.dateTime')}</p>
                                        <div className='txt-right' style={{ width: '50%', wordBreak: 'break-all' }}>
                                            <p style={{ fontWeight: 600 }}>{state?.planHistory?.created_at ?? '-'}</p>
                                        </div>
                                    </div>
                                    <div className='w-full flex-sb-m'>
                                        <p>{t('package.ref')}</p>
                                        <div className='txt-right' style={{ width: '50%', wordBreak: 'break-all' }}>
                                            <p style={{ fontWeight: 600 }}>{state?.planHistory?.ulid ?? '-'}</p>
                                        </div>
                                    </div>
                                    
                                    <div style={{ paddingBottom: 40, paddingTop: 20, textAlign: 'center' }}>
                                        <Button variant="contained" onClick={() => navigate('/home')} style={{ paddingTop: 10, paddingBottom: 10 }}>{t('button.done')}</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            }
            <Dialog open={state.confirmation} onClose={() => {setState({ ...state, confirmation: false }); setPassword(false); setInputErrors({});}}>
                <DialogDesign>
                    <div className='dialog-btn-close' onClick={() => {setState({ ...state, confirmation: false }); setPassword(false); setInputErrors({});}}>
                        <div className=' flex-c-m animate-spin pointer'>
                            <FiX className='fs-23 cl-theme' />
                        </div>
                    </div>
                    <div className='txt-center'>
                        <p className='fs-18' style={{ fontWeight: 600 }}>{t('package.confirmation')}</p>
                        <p className='p-t-4 fs-14 cl-label'>{t('package.confirmationDetails')}</p>
                    </div>
                    <div>
                        <div>
                            <div className='p-t-24 flex-sb-m'>
                                <p>{t('package.quantity')}</p>
                                <p>{1}</p>
                            </div>
                            {packagePriceRender('dialog')}
                        </div>
                        <p className=' p-t-40'>{t('user.securityPassword')}</p>
                        <TextField
                            variant="outlined"
                            fullWidth
                            name='securityPassword'
                            placeholder={t('user.securityPassword')}
                            onChange={handleChange}
                            type={showPassword?.securityPassword ? 'text' : 'password'}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => handleClickShowPassword('securityPassword')}>
                                            {showPassword?.securityPassword ? <MdVisibility className="img-style" style={{ color: theme.palette.inputIconColor }} /> : <MdVisibilityOff className="img-style" style={{ color: theme.palette.inputIconColor }} />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                                disableUnderline: true
                            }}
                            helperText={inputErrors && inputErrors.security_password ? inputErrors.security_password : ''}
                            error={inputErrors && inputErrors.security_password ? true : false}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                                autoComplete: 'new-password'
                           }}
                        />
                    </div>
                    {  password ?
                        <div className='p-t-24'>
                             <Button variant='contained' onClick={navigateSecurityPassword}>{t('user.setSecurityPassword')}</Button>
                        </div>
                        :
                        <div className='w-full p-tb-40 flex-sb-m'>
                            <Button variant="outlined" onClick={() => setState({ ...state, confirmation: false })} style={{ width: '45%' }}>{t('button.cancel')}</Button>
                            <Button variant="contained" onClick={purchase} style={{ width: '45%' }}>{t('button.confirm')}</Button>
                        </div>
                    }


                </DialogDesign>
            </Dialog>
        </div>
    )
}

const useStyles = makeStyles(theme => ({

}));